<template>
  <div class="common_wrap bg_grey color_black relative">
    <div class="main">
      <div v-if="gameUserName" class="account round_5 fs_12 flex_a_c">
        <div class="account_label">已绑定角色</div>
        <!-- <div class="account_value color_yellow">
          {{ gameUserName }}
        </div> -->
      </div>
      <div class="flex_center">
        <div class="gift_tabs">
          <div
            class="gift_tab"
            :class="{
              gift_tab_active: activeTab === 1
            }"
            @click="handleChangeType(1)"
          >常规礼包</div>
          <div
            class="gift_tab"
            :class="{
              gift_tab_active: activeTab === 2
            }"
            @click="handleChangeType(2)"
          >活动礼包</div>
        </div>
      </div>
      <!-- <van-tabs
        v-model="activeTab"
        type="card"
        swipeable
      >
        <van-tab key="1" :name="1" title="常规礼包">
          <div>2222</div>
          <div>3333</div>
        </van-tab>
        <van-tab key="2" :name="2" title="活动礼包">
          <div>4444</div>
          <div>3333</div>
        </van-tab>
      </van-tabs> -->
      <div
        class="tip fs_12 scale08_center text_center mb_12 color_org"
      >礼包有效期30天，请尽快兑换</div>
      <div class="gift_list round_5">
        <van-list
          v-model="pageLoading"
          :finished="pageFinished"
          finished-text="没有更多了"
          @load="getGiftList"
        >
          <div
            v-for="gf in giftList"
            :key="gf.id"
            class="gift bg_white round_5"
          >
            <gift-item-1
              v-if="!loading"
              :name="gf.giftName"
              :desc="gf.content"
              :tag="gf.tag"
              :condition="'礼包领取时间：' + gf.giftReceiveTime"
              :copy="gf.code"
              @copyCb="handleCopyBack(gf)"
            />
            <van-skeleton v-else :row="3" />
          </div>
        </van-list>
        <van-empty
          v-if="hasFetch && !giftList.length"
          class="custom-image"
          image="https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/empty.png"
          description="这里什么都木有哦"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getMyGiftListApi } from '@/apis/activity.api'
import { getGameInfoById } from '@/apis/common.api' 
import GiftItem1 from '@/components/gift/giftItem1.vue';
import store from "@/store";
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import { getListTotalPage } from '@/utils'
const COUNT_ONE_PAGE = 20
export default {
  components: {
    GiftItem1,
  },
  mixins: [trackingMixin],
  data () {
    return {
      accountInfo: {},
      giftList: [],
      activeTab: 1,
      gameUserName: store.getters['user/gameUserName'],
      loading: false,
      hasFetch: false,
      gameId: '',
      gameName: '',
      page: 1,
      pageFinished: false,
      pageLoading: false,
    }
  },
  computed: {
    // 埋点所需的游戏信息
    trackAppInfo () {
      return {
        appkey: this.gameId,
        appName: this.gameName,
      }
    },
  },
  mounted () {
    try {
      const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
      this.gameId = this.$route.query.gameId || params.gameId
    } catch (error) {
      this.$toast('参数获取失败')
    }
    this.init(this.$route.query.tab * 1 || 1)
  },
  methods: {
    init (type) {
      this.handleChangeType(type, true)
    },
    getMainInfo (type = 1, hasEvent = true) {
      this.loading = true
      return this.getGiftList().then(res => {
        if (hasEvent) {
          this.handleGetGameInfo().then(res => {
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_mine_gift_page,
              '',
              this.trackAppInfo
            )
          })
        }
      }).finally(() => this.loading = false)
    },
    getGiftList () {
      const currentPage = this.page > 1 ? this.page : 1
      this.pageLoading = true
      return getMyGiftListApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        gameId: this.gameId,
        page: currentPage,
        size: COUNT_ONE_PAGE,
        type: this.activeTab || 1,
      }).then(res => {
        const { list = [], total, currentPage: c_page } = res.data; 
        const _list = list || []
        const totalPage = getListTotalPage(total, COUNT_ONE_PAGE);
        if (c_page === 1) {
          this.giftList = _list
        } else {
          this.giftList = this.giftList.concat(_list)
        }
        this.page += 1
        this.hasFetch = true
        if (c_page === totalPage) {
          this.pageFinished = true;
        }
      }).catch(() => {
        this.pageFinished = true;
      })
      .finally(() => {
        this.pageLoading = false
      })
    },
    handleChangeType (t, noEvent = false) {
      this.page = 1
      this.pageFinished = false
      this.activeTab = t
      this.getMainInfo(t, noEvent)
      if (!noEvent) {
        this.EVENT_TRACKING(
          EVENT_TYPE_ENUM.wechat_mine_gift_tab_button,
          {
            tab_type: t === 1 ? 0 : 1
          },
          this.trackAppInfo,
        )
      }
    },  
    handleCopyBack ({ id, giftId, giftName }) {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_mine_gift_copy_button,
        {
          id,
          gift_id: giftId,
          gift_name: giftName,
          tab_type: this.activeTab === 1 ? 0 : 1,
        },
        this.trackAppInfo,
      )
    },
    handleGetGameInfo () {
      return getGameInfoById({
        gameId: this.gameId
      }).then(res => {
        const { name } = res.data
        this.gameName = name
      })
    },
    handleReceive () {},
  },
}
</script>

<style lang="scss" scoped>
::v-deep .van-tabs__nav--card .van-tabs__wrap {
  height: 35px;
}

.main {
  padding: 8px 10px;
  .account {
    background: #fff;
    padding: 12px;
  }

  .gift_tabs {
    display: flex;
    align-items: center;
    border-radius: 17.5px;
    overflow: hidden;
    margin: 10px auto 6px;
    .gift_tab {
      background-color: #fff;
      color: #A8A8A8;
      font-size: 15px;
      line-height: 1;
      padding: 10px 36px;
      transition: all 0.3s ease;
    }
    .gift_tab.gift_tab_active {
      background: #FFAA37;
      color: #fff;
    }
    // border-radius: ;
  }

  .gift_list {
    overflow: auto;
    .gift + .gift {
      margin-top: 8px;
    }
  }
}

</style>